export const DiffrenceDatesInMs=(customDate)=>{
    let date2 = new Date();
    let date = new Date(customDate);

    var dif = date.getTime() - date2.getTime();
    var Seconds_from_T1_to_T2 = dif / 1000;
    return Seconds_from_T1_to_T2>0?Seconds_from_T1_to_T2:0;
}
export const IsEqualTwoDates=(firstDate,secondDate)=>{
    let date = new Date(firstDate);
    let date2 = new Date(secondDate);

    var dif = date.getTime() - date2.getTime();
    var Seconds_from_T1_to_T2 = dif / 1000;
    return Seconds_from_T1_to_T2===0;
}
